// extracted by mini-css-extract-plugin
export default {"cls1":"rG98_ICd5JKwp2IicOBx","cls2":"pFkfcvcMF8y7cNJFrqvK rG98_ICd5JKwp2IicOBx"};